import type * as Types from '../../../../../../graphql/generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetCurrentUserQueryVariables = Types.Exact<{
  date: Types.Scalars['Date']['input'];
}>;


export type GetCurrentUserQueryPage = { readonly __typename?: 'RootQueryType', readonly currentUser?: { readonly __typename?: 'AccountsUser', readonly currentCompany?: { readonly __typename?: 'AccountsCompany', readonly id: string, readonly name: string, readonly mediaplanType?: Types.AccountsCompanyMediaplanType | null, readonly sensorExclusions: ReadonlyArray<{ readonly __typename?: 'YalperSensorExclusion', readonly sensorName: string }>, readonly tokens: ReadonlyArray<{ readonly __typename?: 'OauthProviderToken', readonly id: string, readonly lastError?: string | null, readonly provider: Types.OauthProvider, readonly isValid: boolean }>, readonly stats: ReadonlyArray<{ readonly __typename?: 'YalperStat', readonly state: Types.YalperStatsState, readonly platform: Types.YalperPlatform }>, readonly sensorGroups: { readonly __typename?: 'AccountsCompanySensorGroups', readonly red: ReadonlyArray<string>, readonly yellow: ReadonlyArray<string>, readonly gray: ReadonlyArray<string> }, readonly regions: ReadonlyArray<{ readonly __typename?: 'YalperRegion', readonly id: number, readonly name: string }>, readonly lastChecks: ReadonlyArray<{ readonly __typename?: 'YalperCheck', readonly id: string, readonly checks: number, readonly cost: number, readonly found: number, readonly new: number, readonly fixed: number, readonly campaignIds: ReadonlyArray<string>, readonly sensor: { readonly __typename?: 'YalperSensor', readonly id: string, readonly name: string, readonly platform: Types.YalperPlatform, readonly isError: boolean }, readonly campaignChecks: ReadonlyArray<{ readonly __typename?: 'YalperCampaignCheck', readonly campaignId: string, readonly found: number, readonly checks: number }> }> } | null, readonly subscription: { readonly __typename?: 'YalperSubscription', readonly planId?: number | null } } | null };

export type GetCampaignMediaplanStatsQueryVariables = Types.Exact<{
  startDate: Types.Scalars['Date']['input'];
  endDate: Types.Scalars['Date']['input'];
}>;


export type GetCampaignMediaplanStatsQueryPage = { readonly __typename?: 'RootQueryType', readonly currentUser?: { readonly __typename?: 'AccountsUser', readonly currentCompany?: { readonly __typename?: 'AccountsCompany', readonly campaignMediaplanStats: ReadonlyArray<{ readonly __typename?: 'YalperCampaignMediaplanStat', readonly campaignId: string, readonly campaignName: string, readonly accountId: string, readonly accountName: string, readonly mediaplanType: string, readonly spent: number, readonly clicks: number, readonly impressions: number, readonly bounces: number, readonly sessions: number, readonly conversions: number, readonly ePurchaseConversions: number, readonly visits: number, readonly likes: number, readonly comments: number, readonly shares: number, readonly reach: number, readonly revenue: number, readonly videoComplete: number, readonly videoCompleteRate: number, readonly avgVideoCompleteCost: number }> } | null } | null };

export type GetCampaignMediaplanDailyStatsQueryVariables = Types.Exact<{
  startDate: Types.Scalars['Date']['input'];
  endDate: Types.Scalars['Date']['input'];
}>;


export type GetCampaignMediaplanDailyStatsQueryPage = { readonly __typename?: 'RootQueryType', readonly currentUser?: { readonly __typename?: 'AccountsUser', readonly currentCompany?: { readonly __typename?: 'AccountsCompany', readonly campaignMediaplanDailyStats: ReadonlyArray<{ readonly __typename?: 'YalperCampaignMediaplanDailyStat', readonly campaignId: string, readonly campaignName: string, readonly accountId: string, readonly accountName: string, readonly dailyStats: ReadonlyArray<{ readonly __typename?: 'YalperCampaignMediaplanDailyStatItem', readonly collectedOn: string, readonly mediaplanType: string, readonly spent: number, readonly clicks: number, readonly impressions: number, readonly bounces: number, readonly sessions: number, readonly conversions: number, readonly ePurchaseConversions: number, readonly visits: number, readonly likes: number, readonly comments: number, readonly shares: number, readonly reach: number, readonly revenue: number, readonly videoComplete: number, readonly videoCompleteRate: number, readonly avgVideoCompleteCost: number }> }> } | null } | null };

export type GetCampaignParamsQueryVariables = Types.Exact<{
  startDate: Types.Scalars['Date']['input'];
  endDate: Types.Scalars['Date']['input'];
}>;


export type GetCampaignParamsQueryPage = { readonly __typename?: 'RootQueryType', readonly currentUser?: { readonly __typename?: 'AccountsUser', readonly currentCompany?: { readonly __typename?: 'AccountsCompany', readonly id: string, readonly mediaplans: ReadonlyArray<{ readonly __typename?: 'AccountsMediaplan', readonly id: string, readonly startOn: string, readonly endOn?: string | null, readonly kpis?: ReadonlyArray<{ readonly __typename?: 'AccountsKpi', readonly name: Types.AccountsKpiName, readonly value: string | number, readonly primary: boolean }> | null }> } | null, readonly subscription: { readonly __typename?: 'YalperSubscription', readonly planId?: number | null } } | null };


export const GetCurrentUserDocument = gql`
    query GetCurrentUser($date: Date!) {
  currentUser {
    currentCompany {
      id
      name
      mediaplanType
      sensorExclusions {
        sensorName
      }
      tokens {
        id
        lastError
        provider
        isValid
      }
      stats(date: $date) {
        state
        platform
      }
      sensorGroups {
        red
        yellow
        gray
      }
      regions {
        id
        name
      }
      lastChecks {
        id
        checks
        cost
        found
        new
        fixed
        sensor {
          id
          name
          platform
          isError
        }
        campaignIds
        campaignChecks {
          campaignId
          found
          checks
        }
      }
    }
    subscription {
      planId
    }
  }
}
    `;

/**
 * __useGetCurrentUserQuery__
 *
 * To run a query within a React component, call `useGetCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentUserQuery({
 *   variables: {
 *      date: // value for 'date'
 *   },
 * });
 */
export function useGetCurrentUserQuery(baseOptions: Apollo.QueryHookOptions<GetCurrentUserQueryPage, GetCurrentUserQueryVariables> & ({ variables: GetCurrentUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentUserQueryPage, GetCurrentUserQueryVariables>(GetCurrentUserDocument, options);
      }
export function useGetCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentUserQueryPage, GetCurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentUserQueryPage, GetCurrentUserQueryVariables>(GetCurrentUserDocument, options);
        }
export function useGetCurrentUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCurrentUserQueryPage, GetCurrentUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCurrentUserQueryPage, GetCurrentUserQueryVariables>(GetCurrentUserDocument, options);
        }
export type GetCurrentUserQueryHookResult = ReturnType<typeof useGetCurrentUserQuery>;
export type GetCurrentUserLazyQueryHookResult = ReturnType<typeof useGetCurrentUserLazyQuery>;
export type GetCurrentUserSuspenseQueryHookResult = ReturnType<typeof useGetCurrentUserSuspenseQuery>;
export type GetCurrentUserQueryResult = Apollo.QueryResult<GetCurrentUserQueryPage, GetCurrentUserQueryVariables>;
export const GetCampaignMediaplanStatsDocument = gql`
    query GetCampaignMediaplanStats($startDate: Date!, $endDate: Date!) {
  currentUser {
    currentCompany {
      campaignMediaplanStats(startDate: $startDate, endDate: $endDate) {
        campaignId
        campaignName
        accountId
        accountName
        mediaplanType
        spent
        clicks
        impressions
        bounces
        sessions
        conversions
        ePurchaseConversions
        visits
        likes
        comments
        shares
        reach
        revenue
        videoComplete
        videoCompleteRate
        avgVideoCompleteCost
      }
    }
  }
}
    `;

/**
 * __useGetCampaignMediaplanStatsQuery__
 *
 * To run a query within a React component, call `useGetCampaignMediaplanStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCampaignMediaplanStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCampaignMediaplanStatsQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGetCampaignMediaplanStatsQuery(baseOptions: Apollo.QueryHookOptions<GetCampaignMediaplanStatsQueryPage, GetCampaignMediaplanStatsQueryVariables> & ({ variables: GetCampaignMediaplanStatsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCampaignMediaplanStatsQueryPage, GetCampaignMediaplanStatsQueryVariables>(GetCampaignMediaplanStatsDocument, options);
      }
export function useGetCampaignMediaplanStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCampaignMediaplanStatsQueryPage, GetCampaignMediaplanStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCampaignMediaplanStatsQueryPage, GetCampaignMediaplanStatsQueryVariables>(GetCampaignMediaplanStatsDocument, options);
        }
export function useGetCampaignMediaplanStatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCampaignMediaplanStatsQueryPage, GetCampaignMediaplanStatsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCampaignMediaplanStatsQueryPage, GetCampaignMediaplanStatsQueryVariables>(GetCampaignMediaplanStatsDocument, options);
        }
export type GetCampaignMediaplanStatsQueryHookResult = ReturnType<typeof useGetCampaignMediaplanStatsQuery>;
export type GetCampaignMediaplanStatsLazyQueryHookResult = ReturnType<typeof useGetCampaignMediaplanStatsLazyQuery>;
export type GetCampaignMediaplanStatsSuspenseQueryHookResult = ReturnType<typeof useGetCampaignMediaplanStatsSuspenseQuery>;
export type GetCampaignMediaplanStatsQueryResult = Apollo.QueryResult<GetCampaignMediaplanStatsQueryPage, GetCampaignMediaplanStatsQueryVariables>;
export const GetCampaignMediaplanDailyStatsDocument = gql`
    query GetCampaignMediaplanDailyStats($startDate: Date!, $endDate: Date!) {
  currentUser {
    currentCompany {
      campaignMediaplanDailyStats(startDate: $startDate, endDate: $endDate) {
        campaignId
        campaignName
        accountId
        accountName
        dailyStats {
          collectedOn
          mediaplanType
          spent
          clicks
          impressions
          bounces
          sessions
          conversions
          ePurchaseConversions
          visits
          likes
          comments
          shares
          reach
          revenue
          videoComplete
          videoCompleteRate
          avgVideoCompleteCost
        }
      }
    }
  }
}
    `;

/**
 * __useGetCampaignMediaplanDailyStatsQuery__
 *
 * To run a query within a React component, call `useGetCampaignMediaplanDailyStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCampaignMediaplanDailyStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCampaignMediaplanDailyStatsQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGetCampaignMediaplanDailyStatsQuery(baseOptions: Apollo.QueryHookOptions<GetCampaignMediaplanDailyStatsQueryPage, GetCampaignMediaplanDailyStatsQueryVariables> & ({ variables: GetCampaignMediaplanDailyStatsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCampaignMediaplanDailyStatsQueryPage, GetCampaignMediaplanDailyStatsQueryVariables>(GetCampaignMediaplanDailyStatsDocument, options);
      }
export function useGetCampaignMediaplanDailyStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCampaignMediaplanDailyStatsQueryPage, GetCampaignMediaplanDailyStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCampaignMediaplanDailyStatsQueryPage, GetCampaignMediaplanDailyStatsQueryVariables>(GetCampaignMediaplanDailyStatsDocument, options);
        }
export function useGetCampaignMediaplanDailyStatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCampaignMediaplanDailyStatsQueryPage, GetCampaignMediaplanDailyStatsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCampaignMediaplanDailyStatsQueryPage, GetCampaignMediaplanDailyStatsQueryVariables>(GetCampaignMediaplanDailyStatsDocument, options);
        }
export type GetCampaignMediaplanDailyStatsQueryHookResult = ReturnType<typeof useGetCampaignMediaplanDailyStatsQuery>;
export type GetCampaignMediaplanDailyStatsLazyQueryHookResult = ReturnType<typeof useGetCampaignMediaplanDailyStatsLazyQuery>;
export type GetCampaignMediaplanDailyStatsSuspenseQueryHookResult = ReturnType<typeof useGetCampaignMediaplanDailyStatsSuspenseQuery>;
export type GetCampaignMediaplanDailyStatsQueryResult = Apollo.QueryResult<GetCampaignMediaplanDailyStatsQueryPage, GetCampaignMediaplanDailyStatsQueryVariables>;
export const GetCampaignParamsDocument = gql`
    query GetCampaignParams($startDate: Date!, $endDate: Date!) {
  currentUser {
    currentCompany {
      id
      mediaplans(endDate: $endDate, startDate: $startDate) {
        id
        startOn
        endOn
        kpis {
          name
          value
          primary
        }
      }
    }
    subscription {
      planId
    }
  }
}
    `;

/**
 * __useGetCampaignParamsQuery__
 *
 * To run a query within a React component, call `useGetCampaignParamsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCampaignParamsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCampaignParamsQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGetCampaignParamsQuery(baseOptions: Apollo.QueryHookOptions<GetCampaignParamsQueryPage, GetCampaignParamsQueryVariables> & ({ variables: GetCampaignParamsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCampaignParamsQueryPage, GetCampaignParamsQueryVariables>(GetCampaignParamsDocument, options);
      }
export function useGetCampaignParamsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCampaignParamsQueryPage, GetCampaignParamsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCampaignParamsQueryPage, GetCampaignParamsQueryVariables>(GetCampaignParamsDocument, options);
        }
export function useGetCampaignParamsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCampaignParamsQueryPage, GetCampaignParamsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCampaignParamsQueryPage, GetCampaignParamsQueryVariables>(GetCampaignParamsDocument, options);
        }
export type GetCampaignParamsQueryHookResult = ReturnType<typeof useGetCampaignParamsQuery>;
export type GetCampaignParamsLazyQueryHookResult = ReturnType<typeof useGetCampaignParamsLazyQuery>;
export type GetCampaignParamsSuspenseQueryHookResult = ReturnType<typeof useGetCampaignParamsSuspenseQuery>;
export type GetCampaignParamsQueryResult = Apollo.QueryResult<GetCampaignParamsQueryPage, GetCampaignParamsQueryVariables>;